import React, { useEffect, useState } from 'react';
import { initialsOf } from '../lib/format';
import { loadAvatar } from '../lib/avatars';

// The single place in the app that turns a member id into a picture.
//
// Initials remain the fallback for every case that is not a successfully
// loaded photo: no photo, a refused fetch, a failed render. A broken image is
// never shown. Decorative by default, because the person's name is always
// immediately adjacent and a screen reader should not announce it twice.
export const Avatar = ({ userId, name, photoUrl, className = '', testId }) => {
  const [src, setSrc] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setSrc(null);
    loadAvatar(userId, photoUrl).then((url) => {
      if (!cancelled) setSrc(url);
    });
    return () => {
      cancelled = true;
    };
  }, [userId, photoUrl]);

  return (
    <span className={className} aria-hidden="true" data-testid={testId}>
      {src ? (
        <img className="avatar-img" src={src} alt="" onError={() => setSrc(null)} />
      ) : (
        initialsOf(name)
      )}
    </span>
  );
};
